module.exports = __webpack_public_path__ + "img/park3.63515a82.png";